import ReactDOM from 'react-dom/client'

import './index.css'
import App from './scenes/Home/App'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<App />)
